const mensagemErro = {
    marginTop: -25, 
    fontSize: 12, 
    color: 'yellow'
}

export {mensagemErro}